<template>
<div class="container-fluid mt-5">
    <h3 class="text-blue mt-5">{{trainingDetails.title}}</h3>

    <div class="row mt-5">
        <div class="col-sm-7">
            <h4 class="text-blue">Event Brief Information</h4>
        </div>
        <div class="col-sm-5">
            <a @click="printPage" class="btn btn-primary text-uppercase btn-report float-right ml-3">Print Event Details</a>

        </div>
    </div>

    <div class="row mt-3">
        <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.district != undefined && trainingDetails.district.province != undefined && trainingDetails.district.province.country != undefined">
            <label class="mr-2 font-weight-bold">Country</label>
            {{trainingDetails.district.province.country.title}}
        </div>

        <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.district != undefined && trainingDetails.district.province != undefined">
            <label class="mr-2 font-weight-bold">Province</label>
            {{trainingDetails.district.province.title}}
        </div>

        <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.district != undefined">
            <label class="mr-2 font-weight-bold">City</label>
            {{trainingDetails.district.title}}
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.advisor != undefined">
            <label class="mr-2 font-weight-bold">Advisor</label>
            {{trainingDetails.advisor.name}}
        </div>

        <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.programofficer != undefined">
            <label class="mr-2 font-weight-bold">Program Officer</label>
            {{trainingDetails.programofficer.name}}
        </div>

        <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.subprogram != undefined">
            <label class="mr-2 font-weight-bold">Sub Program / Project</label>
            {{trainingDetails.subprogram.title}}
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-sm-4" v-if="doners">
            <label class="mr-2 font-weight-bold">Donor</label>
            <span v-for="(doner,index) in doners" v-bind:key="index">{{doner.title}} ,</span>
        </div>

        <div class="col-sm-8" v-if="alltrainers">
            <label class="mr-2 font-weight-bold">Trainers</label>
            <span v-for="(trainer,trIndex) in alltrainers" v-bind:key="trIndex">{{trainer.trainer.name}} ,</span>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-sm-4">
            <label class="mr-2 font-weight-bold">Start Date</label>
            {{trainingDetails.startdate}}
        </div>

        <div class="col-sm-4">
            <label class="mr-2 font-weight-bold">End Date</label>
            {{trainingDetails.enddate}}
        </div>

        <div class="col-sm-4">
            <label class="mr-2 font-weight-bold">No. of Days</label>
            {{trainingDetails.noofdays}}
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-sm-7">
            <h4 class="text-blue">Attendees Information</h4>
        </div>

        <div class="table-responsive pl-3">
            <table class="table table-borderless mt-3">
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>CNIC</th>
                        <th>Designation</th>
                        <th>Department</th>
                        <th>Email</th>
                        <th>Number</th>
                        <th>Attendance</th>
                    </tr>
                </thead>
            </table>
            <h5 class="text-blue">Trainees</h5>
            <table class="table table-borderless mt-3" v-if="allTrainees">
                <tbody>
                    <tr v-for="(trainee,tIndex) in allTrainees" v-bind:key="tIndex">
                        <td>{{tIndex+1}}</td>
                        <td v-if="trainee.trainee.userstrainee.name">{{trainee.trainee.userstrainee.name}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainee.trainee.cnic">{{trainee.trainee.cnic}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainee.trainee.designation">{{trainee.trainee.designation}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainee.trainee.department_name">{{trainee.trainee.department_name}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainee.trainee.userstrainee.username">{{trainee.trainee.userstrainee.username}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainee.trainee.userstrainee.contactNo">{{trainee.trainee.userstrainee.contactNo}}</td>
                        <td v-else>N/A</td>
                        <td>Present</td>
                    </tr>
                </tbody>
            </table>
            <h5 class="text-blue">UNODC Staff & Facilitators</h5>
            <table class="table table-borderless mt-3" v-if="trainingDetails !='' && trainingDetails.programofficer">
                <tbody>
                    <tr>
                        <td>1</td>
                        <td v-if="trainingDetails.programofficer.name">{{trainingDetails.programofficer.name}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainingDetails.programofficer.cnic">{{trainingDetails.programofficer.cnic}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainingDetails.programofficer.designations">{{trainingDetails.programofficer.designations.title}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainingDetails.programofficer.departments">{{trainingDetails.programofficer.departments.title}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainingDetails.programofficer.username">{{trainingDetails.programofficer.username}}</td>
                        <td v-else>N/A</td>
                        <td v-if="trainingDetails.programofficer.contactNo">{{trainingDetails.programofficer.contactNo}}</td>
                        <td v-else>N/A</td>
                        <td>Present</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        isActve1: 1,
        trainingCode: "",
        trainingDetails: [],
        trainingId: "",
        alltrainers: [],
        allTrainees: [],
        doners: [],
        isSidebar: false,
        colorx: "warning"
    }),
    components: {},
    created() {},
    methods: {
        printPage() {
            window.print();
        },
        showTrainers: function showTrainers(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/trainer/get/" +
                    tId
                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.alltrainers = response.data;
                });
        },
        showTrainees: function showTrainees(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/traineedetails/report/get/" +
                    tId
                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.allTrainees = response.data.trainees;
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        }
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode
            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                if (response.data && response.data.training) {
                    this.trainingDetails = response.data.training;
                    this.showTrainers(response.data.training.id);
                    this.showTrainees(response.data.training.id);
                }
                if (response.data && response.data.doner) {
                    this.doners = response.data.doner;
                }
            });
    }
};
</script>

<style scoped>
.text-blue {
    color: #00a4ea;
}

.btn-report {
    background-color: #6488d2 !important;
    border-radius: 0px !important;
    padding: 3px 30px !important;
}

.table th,
.table td {
    width: 10%;
}

@media print {

    /* Hide elements we don't want to print */
    .btn-report {
        display: none !important;
    }

    /* Ensure proper page breaks */
    .table {
        page-break-inside: avoid;
    }

    /* Reset colors for better printing */
    .text-blue {
        color: #000 !important;
    }

    /* Ensure content takes full width */
    .container-fluid {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .print-media {
        display: none !important;
    }
}
</style>
